export default __webpack_public_path__ + "static/media/referral.ab643f62.svg";